import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Check, Loader2, X } from "lucide-react";
import { useLang } from "../i18n";
import { useAuth } from "../context/AuthContext";
import api from "../lib/api";

export const PaymentSuccess = () => {
  const { t } = useLang();
  const { refreshUser } = useAuth();
  const [params] = useSearchParams();
  const [status, setStatus] = useState("checking");
  const [isMembership, setIsMembership] = useState(false);

  useEffect(() => {
    const sessionId = params.get("session_id");
    if (!sessionId) { setStatus("done"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setIsMembership((data.lookup_key || "").startsWith("membership"));
          await refreshUser();
          setStatus("done");
          return;
        }
      } catch { /* ignore */ }
      if (tries++ < 10) setTimeout(poll, 2000);
      else setStatus("done");
    };
    poll();
  }, []); // eslint-disable-line

  return (
    <div data-testid="payment-success" className="min-h-screen flex flex-col items-center justify-center px-6 text-center">
      {status === "checking" ? (
        <>
          <Loader2 className="w-10 h-10 animate-spin text-primary mb-6" />
          <p className="font-serif text-2xl text-foreground/70">{t("payment.checking")}</p>
        </>
      ) : (
        <>
          <div className="w-20 h-20 bg-primary text-primary-foreground rounded-full flex items-center justify-center mb-8"><Check className="w-10 h-10" /></div>
          <h1 className="font-serif text-5xl md:text-6xl tracking-tightest text-foreground mb-5">{t("payment.successTitle")}</h1>
          <p className="text-foreground/65 font-light max-w-md mb-10">{t("payment.successSub")}</p>
          <div className="flex gap-4">
            <Link to="/" className="border border-border px-8 py-3.5 text-sm hover:border-primary transition-colors">{t("payment.home")}</Link>
            {isMembership && <Link to="/members" className="bg-primary text-primary-foreground px-8 py-3.5 text-sm hover:bg-primary/90 transition-colors">{t("payment.members")}</Link>}
          </div>
        </>
      )}
    </div>
  );
};

export const PaymentCancel = () => {
  const { t } = useLang();
  return (
    <div data-testid="payment-cancel" className="min-h-screen flex flex-col items-center justify-center px-6 text-center">
      <div className="w-20 h-20 bg-muted text-foreground/50 rounded-full flex items-center justify-center mb-8"><X className="w-10 h-10" /></div>
      <h1 className="font-serif text-5xl md:text-6xl tracking-tightest text-foreground mb-5">{t("payment.cancelTitle")}</h1>
      <p className="text-foreground/65 font-light max-w-md mb-10">{t("payment.cancelSub")}</p>
      <Link to="/" className="bg-primary text-primary-foreground px-8 py-3.5 text-sm hover:bg-primary/90 transition-colors">{t("payment.home")}</Link>
    </div>
  );
};
